import { ClearableTextInput, Collection, CollectionView, DestroyingContentSwitcher, Div, Filters, Ref, RefString, Select, Snack } from "@tblabs/truffle";
import { Router } from "../../../Services/Router";
import { AuthService } from "../../../Services/Auth/AuthService";
import { Order } from "../../../Models/Order";
import { OrdersManager } from "../../../Services/OrdersManager";
import { StepsView } from "./Views/Steps/StepsView";
import { TableView } from "./Views/Table/TableView";
import { TodoView } from "./Views/ToDo/TodoView";
import { CalendarView } from "./Views/Calendar/CalendarView";
import { ProfitView } from "./Views/Calendar/ProfitView";
import { TasksView } from "./Views/Tasks/TasksView";
import { AgentsProvider } from "../../../Services/AgentsProvider";
import { OriginsView } from "./OriginsView";


export class OrdersViewPage extends Div
{
    constructor(private _manager: OrdersManager, private _router: Router, private _auth: AuthService, private _agents: AgentsProvider)
    {
        super("AdminPage");

        this.Append(`Ładowanie zamówień...`)
    }

    protected async OnAppend(): Promise<void>
    {
        try
        {
            if (!this._auth.IsAuthorized)
            {
                this.Append(`Brak autoryzacji. Zaloguj się aby zobaczyć te stronę`);
                return;
            }

            const ordersSet = new Ref<"Current" | "Closed">("Current").Storable("orders-set");

            const orders: Order[] = await this._manager.GetAll(ordersSet.value);
            orders.forEach(x => x.SelfSetup());
            orders.sort((a, b) => +b.Meta.CreatedAt - +a.Meta.CreatedAt);

            const view = new RefString("steps").Storable("orders-view");

            const filter = new RefString().Storable("orders-filter");
            filter.OnChange(() => view.value = "table");

            const ordersCollection = new Collection(orders);
            const ordersView = new CollectionView(ordersCollection)
                .Filter(filter, order => Filters.TextContains(filter, [order.SearchBy]))
                .Refresh()

            const content = new DestroyingContentSwitcher(view)
                .AddContent("table", () => new TableView(this._router, this._manager, ordersView))
                .AddContent("calendar", () => new CalendarView(this._router, ordersView))
                // .AddContent("steps", () => new StepsView(this._router, this._agents, this._manager, ordersView))
                .AddContent("todo", () => new TodoView(this._router, this._manager, this._agents, ordersView))
                .AddContent("profit", () => new ProfitView(ordersView))
                .AddContent("tasks", () => new TasksView(ordersView))
                .AddContent("origins", () => new OriginsView(ordersView))

            ordersSet.OnChange(async (set) =>
            {
                const orders: Order[] = await this._manager.GetAll(set);
                ordersCollection.Load(...orders);

                content.Refresh();
            })

            this.Clear().Append(
                new Select(ordersSet, { "🟢 Aktualne": "Current", "🟤 Zamknięte": "Closed" }).WidthAuto().Margin(8),
                new ClearableTextInput(filter, "Szukaj...").DisplayInlineBlock().WidthAuto(),
                new Select(view, {
                    "🍔 Tabela": "table",
                    "🍂 Zadania": "todo",
                    "🚀 Akcje": "tasks",
                    "📅 Kalendarz": "calendar",
                    "💰 Profit": "profit",
                    // "🐾 Kroki": "steps",
                    "🧭 Źródła": "origins",
                }).WidthAuto().Margin(8).FloatRight().PaddingRight(32),
                new Div().ClearBoth(),
                content,
            )
        }
        catch (ex: any)
        {
            new Snack(`❌ Wystąpił błąd podczas ładowania zamówień`, ex.message, { autoCloseTimeout: 0 });
            console.error(ex);
        }
    }
}
